import { Switch, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '../styles/global-styles';
import { theme } from '../styles/theme';
import Login from '../pages/Login';
import PrivateRoute from './PrivateRoute';
import LoginRoute from './LoginRoute';
import MainLayout from '../pages/layouts/MainLayout';
import { AppContext } from '../context/ApiContext';
import Register from '../pages/Register';
import Verify from '../pages/Verify';
import Redefine from '../pages/Redefine';
import RedefinePassword from '../pages/RedefinePassword';
import ExternalIndicationNoAuth from '../pages/ExternalIndicationNoAuth/index';

const Routes = () => {
  const location = useLocation();
  return (
    <Switch>
      <AppContext>
        <AnimatePresence>
          <ThemeProvider theme={theme}>
            <LoginRoute path="/verify/:hash" component={Verify} />
            <LoginRoute path="/redefine/:hash" component={RedefinePassword} />
            <LoginRoute path="/redefine" component={Redefine} />
            <LoginRoute path="/login" component={Login} />
            {/* <LoginRoute path="/register" component={Register} /> */}
            <PrivateRoute path="/externalIndicationNoAuth/verify" component={ExternalIndicationNoAuth} />
            {!location.pathname.includes('verify') && !location.pathname.includes('redefine') && (
              <PrivateRoute path="/" component={MainLayout} />
            )}
            <GlobalStyles />
          </ThemeProvider>
        </AnimatePresence>
      </AppContext>
    </Switch>
  );
};

export default Routes;
